/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ToolBarItemController", ["ControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ToolBarItemController
   * @memberOf classes
   * @extends classes.ControllerBase
   */
  class ToolBarItemController extends cls.ControllerBase /** @lends classes.ToolBarItemController.prototype */ {
    static __name = "ToolBarItemController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      this._addBehavior(cls.LayoutInfoVMBehavior);
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // 4st behaviors
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);
      this._addBehavior(cls.DefaultTTFColor4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledButtonVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.ImageVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.TextActionVMBehavior);

      // ScaleIcon requires that the image is already present
      this._addBehavior(cls.ScaleIcon4STBehavior, true);

      // ui behaviors
      this._addBehavior(cls.OnClickUIBehavior);
      this._addBehavior(cls.InterruptUIBehavior);
    }

    _getWidgetType(kind, active) {
      let type;
      if (this.isInChromeBar()) {
        type = "Item";
      } else {
        type = super._getWidgetType(kind, active);
      }
      return type;
    }

    /**
     * @inheritDoc
     */
    attachUI() {
      super.attachUI();
      if (this.isInChromeBar()) {
        const actionService = this.getAnchorNode().getApplication().getActionApplicationService();
        actionService.registerAction(this.getAnchorNode());
      }
    }

    /**
     * @inheritDoc
     */
    detachUI() {
      const actionService = this.getAnchorNode().getApplication().getActionApplicationService();
      const actionName = this.getAnchorNode().attribute("name");
      if (actionService.hasAction(actionName)) {
        actionService.destroyAction(this.getAnchorNode());
      }
      super.detachUI();
    }
  }

  cls.ToolBarItemController = ToolBarItemController;
  cls.ControllerFactory.register("ToolBarItem", cls.ToolBarItemController);
});
